import { Trans, useTranslation } from 'react-i18next'

import DoneOutlineIcon from '@/components/assets/DoneOutlineIcon'
import NotInterestedIcon from '@/components/assets/NotInterestedIcon'
import { Flex } from '@/components/ui/flex'
import { Link } from '@/components/ui/link'
import { InfoTip } from '@/components/ui/toggle-tip'
import { Text } from '@/components/ui/typography'
import { LINKS } from '@/constants'
import { type TI18nKey } from '@/i18n'
import { IConversationSettings } from '@/types/gigiChat/ConversationSettings'

const CSISearchTooltip = ({ chatSettings, isSearch }: { chatSettings: IConversationSettings | null; isSearch?: boolean }) => {
    const { t } = useTranslation()
    const getLabel = () => {
        if (chatSettings?.processingStrategy === 'Writing' && chatSettings.processingStrategyWriting.model === 'bing-grounding') {
            return t('global.csi.descriptions.writingWebSearch.textInput.long')
        }

        switch (chatSettings?.processingStrategy) {
            case 'QA':
                return t('global.csi.descriptions.qa.textInput.long')
            case 'Writing':
                return t('global.csi.descriptions.writing.textInput.long')
            case 'DocAnalysis':
                return isSearch
                    ? t('global.csi.descriptions.docAnalysis.textInput.long')
                    : t('global.csi.descriptions.docAnalysis.onDocumentUpload.long')
            case 'Translation':
                return isSearch
                    ? t('global.csi.descriptions.translationMode.textInput.long')
                    : t('global.csi.descriptions.translationMode.onDocumentUpload.long')
            default:
                return ''
        }
    }

    if (!chatSettings) {
        return null
    }

    return (
        <InfoTip
            content={
                <Trans
                    i18nKey={getLabel() as TI18nKey}
                    components={{
                        bold: <b />,
                        text: <Text fontSize="12px" lineHeight="initial" />,
                        text2: <Text fontSize="12px" lineHeight="initial" pl="21px" />,
                        flex: <Flex mt="12px" />,
                        link: <Link isExternal href={LINKS.PRIVACY} textDecoration="underline" />,
                        noIcon: (
                            <NotInterestedIcon
                                color="var(--chakra-colors-status-error)"
                                style={{ width: '13px', height: '18px', marginRight: '8px' }}
                            />
                        ),
                        yesIcon: (
                            <DoneOutlineIcon
                                color="var(--chakra-colors-status-success)"
                                style={{ width: '13px', height: '18px', marginRight: '8px' }}
                            />
                        ),
                        yesIconGray: (
                            <DoneOutlineIcon
                                color="var(--chakra-colors-gray-800"
                                style={{ width: '13px', height: '18px', marginRight: '8px' }}
                            />
                        ),
                        link1: (
                            <Link
                                href="https://myconnect.gsk.com/sites/modern-InfoProtect#/sitepages/GSK-4-CATEGORIES-OF-INFORMATION.aspx"
                                isExternal
                                key="https://myconnect.gsk.com/sites/modern-InfoProtect#/sitepages/GSK-4-CATEGORIES-OF-INFORMATION.aspx"
                                textDecoration="underline"
                            />
                        ),
                        link2: (
                            <Link
                                href="https://myconnect.gsk.com/sites/modern-privacy#/sitepages/CLASSIFICATION-VS-CATEGORISATION.aspx"
                                isExternal
                                key="https://myconnect.gsk.com/sites/modern-privacy#/sitepages/CLASSIFICATION-VS-CATEGORISATION.aspx"
                                textDecoration="underline"
                            />
                        ),
                        link3: (
                            <Link
                                href="https://www.microsoft.com/en-us/privacy/privacystatement"
                                isExternal
                                key="https://www.microsoft.com/en-us/privacy/privacystatement"
                                textDecoration="underline"
                            />
                        ),
                    }}
                />
            }
        />
    )
}

export default CSISearchTooltip
